import React from "react";
import "./Skills.css";
import Nav from "../Nav";
import { Link,withRouter} from "react-router-dom";

class Skills extends React.Component {
  render() {
    return (
      <div>
      <Nav/>
      <div className="row jumbotron">
        <div className="col-4 jumbotron" style={{height: '150vh'}}>
          <div className="container">
          <hr style={{backgroundColor: 'black', width: '100%'}}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/About">01 About Us</a></p>
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/Skills"> 02 Governance Structure</a></p>
              <hr style={{backgroundColor: 'black',width: '100%' }}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/Partners">03 Partners & Potential Investors</a></p>
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/Values">04 Our Core Values</a></p>
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
          </div>
        </div>
      <div className="col-8">
      <div class="abhead2">
      <p></p>
      </div>
      <div class="jumbotron">
        <p style={{margin: 0, fontWeight: 'bold'}}>MENTORSHIP, ADVISORY, SUPERVISORY AND MANAGEMENT STRUCTURE</p>
        <hr style={{margin: 0, backgroundColor: 'green'}} className="w-100"/>
        <p style={{fontWeight: 'bold'}} className="text-justify">Mentorship and Investment Promotion Board – Mentors and Representative of the Investor Community</p>
          <div className="">
            <div >
              <p>The Mentorship and Investment Promotion Board will provide mentorship and promote investment.
The Mentorship and Investment Promotion Board will comprise five (5) individuals chosen from the investor community and masters of industry with an independent chairperson. The composition of the Investment Promotion and Mentorship Board will reflects the diversity of investors, institutions and regions within “GOOD MORNING BAMBOO” community. The Investment Promotion and Mentorship Board will meet around two (2) times a year, including an annual retreat.<br/><br/>
The Mentorship and Investment Promotion Board will provide mentorship and investment promotion for GOOD MORNING BAMBOO in the areas of Tax exemptions and obligations, Climate Change mitigation and adaptation; housing deficit and unemployment, especially the youths and women. 
<br/><br/>It will inform the multi-annual strategy and aspects of strategic relevance to the Company “GOOD MORNING BAMBOO”.
</p>
            <p  style={{fontWeight: 'bold'}} className="mt-5 text-center">Investment Promotion & Mentorship Board Members in 2020/21:</p>
            <table class="table table-bordered table-dark">
  
  <tbody>
    <tr>
      <th scope="row">1</th>
      <td colspan="2">Archibald A. Worwui</td>
      <td>Chairman </td>

    </tr>
    <tr>
      <th scope="row">2</th>
      <td colspan="2">...</td>
      <td>...</td>
    </tr>
    <tr>
      <th scope="row">3</th>
      <td colspan="2">...</td>
      <td>...</td>
    </tr>
    <tr>
      <th scope="row">4</th>
      <td colspan="2">...</td>
      <td>...</td>
    </tr>
    <tr>
      <th scope="row">5</th>
      <td colspan="2">...</td>
      <td>...</td>
    </tr>
  </tbody>
</table>
            </div>
            <div className="">
            <p  style={{fontWeight: 'bold'}} className="mt-5">The Founder will appoint the Chairpersons and the limited Independent Members of the following Boards;</p>
            <ul>
              <li>Governing/Supervisory Board</li>
              <li>Advisory Council</li>
              <li>Mentorship and Investment Promotion Board</li>
            </ul>
            <p>The Investment Promotion and Mentorship Board will meet every quarter - four (4) times a year, including an annual retreat.
            The Governing/Supervisory Board is the legal representative of, and legally represent, the <span style={{fontWeight: 'bold'}}>“GOOD MORNING BAMBOO AGRO-FORESTRY AND INVESTMENT SERVICES”</span>
      </p>
            </div>
            </div>    
            <hr style={{margin: 0, backgroundColor: 'green'}} className="w-100"/>
            <div className="">
            <div className="">
            <p  style={{fontWeight: 'bold'}} className="mt-5">Governing/Supervisory Board Members in 2020/21:</p>
            <table class="table table-bordered table-dark">
  
  <tbody>
    <tr>
      <th scope="row">1</th>
      <td colspan="2">Pastor Ernestina Hawkson – Pastor, CCC; Founder of Porter’s Hand Dream Centre; Accelerated Christian Education Ltd. – Destiny ChildCare</td>
      <td>Chairperson </td>

    </tr>
    <tr>
      <th scope="row">2</th>
      <td colspan="2">Engr. Samuel Kwaku Worwui – Founder & CEO</td>
      <td>Executive Director</td>
    </tr>
    <tr>
      <th scope="row">3</th>
      <td colspan="2">Ing. Dr. Appiah-Kubi – Structural Engineering Director & Bamboo Expert</td>
      <td>Statutory Director</td>
    </tr>
    <tr>
      <th scope="row">4</th>
      <td colspan="2">Ing. Dr. Anthony Andrews – Material Technology & Engineering Director</td>
      <td>Statutory Director</td>
    </tr>
    <tr>
      <th scope="row">5</th>
      <td colspan="2">Dr. Edward Yeboah – Soils & Biochar Technical Director</td>
      <td>Statutory Director</td>
    </tr>
    <tr>
      <th scope="row">6</th>
      <td colspan="2">Favour Mawuwoe Worwui – Director of Administration & Marketing</td>
      <td>Senior Management Team Member</td>
    </tr>
    <tr>
      <th scope="row">7</th>
      <td colspan="2">Michael Vandyke – Financial Director</td>
      <td>Senior Management Team Member</td>
    </tr>
    <tr>
      <th scope="row">8</th>
      <td colspan="2">Mandy Dzomeku – Deputy Director, Sustainable Water Resources Management & Board Secretary </td>
      <td>Senior Management Team Member</td>
    </tr>
  </tbody>
</table>
           
            </div>
            <div className="">
            <p  style={{fontWeight: 'bold'}} className="mt-5 text-center">Advisory Council – Highly Experienced, Multicultural and Connected Individuals</p>
            <p className="text-justify">In support of “GOOD MORNING BAMBOO COMMUNITY’s” designed system of multi-funded catalyst of systemic change, we will need to tap into the collective intelligence and guidance of highly experienced multicultural and highly connected individuals – our Advisory Council. Members of the Advisory Council will play an important complementary role to the “GOOD MORNING BAMBOO” investor community as a strategic sounding board for “GOOD MORNING BAMBOO’S” management team, offering an element of independence, fresh perspectives, and divergent thinking. Advisory Council members also will help to represent “GOOD MORNING BAMBOO” externally – including at the UN, European Commission level, in the Technical Expert Groups on Sustainable Finance, etc., helping to develop a unified worldwide classification system for sustainable economies.
The Investment Promotion and Mentorship Board will meet every quarter - four (4) times a year, including an annual retreat.
</p>
            </div>
            </div>  
           
            <div className="">
            <div className="">
            <h2  style={{fontWeight: 'bold'}} className="mt-5 text-center">Advisory Council Members in 2020/21:</h2>
            <hr style={{margin: 0, backgroundColor: 'green'}} className="w-100"/> 
            <table class="table table-bordered table-dark">
  
  <tbody>
    <tr>
      <th scope="row">1</th>
      <td colspan="2">Engr. Mrs Miriam Eduful</td>
      <td>Independent Member</td>
    </tr>
    <tr>
      <th scope="row">2</th>
      <td colspan="2">Engr. Mrs Dorothy Manu</td>
      <td>Independent Member</td>
    </tr>
  </tbody>
</table>
            </div>
            <div className="">
            <h2  style={{fontWeight: 'bold'}} className="mt-5 text-center">Senior Management Team</h2>
            <p className="text-justify">The Senior Management Team is responsible for the day-to-day running/operations of the “GOOD MORNING BAMBOO” General Community under the strictest supervision of the Supervisory Board which takes regular council from the Advisory Council and mentorship and investment promotion opportunities from the Mentorship and Investment Promotion Board</p>
            <h2 style={{fontWeight: 'bold'}} className="mt-5 text-center">Management Team Members in 2020/21:</h2>
            <table class="table table-bordered table-dark">
  
  <tbody>
    <tr>
      <th scope="row">1</th>
      <td colspan="2">Samuel Kwaku Worwui – CEO, Green Building Expert & Construction Technology & Management Engineer</td>
      <td>Founder & Executive Director</td>

    </tr>
    <tr>
      <th scope="row">2</th>
      <td colspan="2">Ing. Dr. Appiah-Kubi – Structural Engineering Director & Bamboo Expert</td>
      <td>Director</td>
    </tr>
    <tr>
      <th scope="row">3</th>
      <td colspan="2">Ing. Dr. Anthony Andrews – Materials Technology Director & Materials Expert</td>
      <td>Director</td>
    </tr>
    <tr>
      <th scope="row">4</th>
      <td colspan="2">Dr. Edward Yeboah – Soils & Biochar Technical Director</td>
      <td>Director</td>
    </tr>
    <tr>
      <th scope="row">5</th>
      <td colspan="2">Favour Mawuwoe Worwui – Administration & Marketing Director</td>
      <td>Director</td>
    </tr>
    <tr>
      <th scope="row">6</th>
      <td colspan="2">Michael Vandyke – Finance Director</td>
      <td>Director</td>
    </tr>
    <tr>
      <th scope="row">7</th>
      <td colspan="2">Mandy Edinam Dzomeku – Sustainable Water Resources Management - Deputy Director</td>
      <td>Deputy Director</td>
    </tr>
  </tbody>
</table>
<div className="row">
  <p style={{fontWeight: 'bold', margin: '0'}}>Profile of Senior Management Team Members</p>
  <hr style={{margin: 0, backgroundColor: 'green'}} className="w-100"/>
  <div className="col-6">
  <p style={{margin: '0', fontWeight: 'bold'}}>Engr. Samuel Worwui, Founder & CEO</p>
  <p className="text-justify">Engr. Samuel Kwaku Worwui, is a Green Building Expert; Fellow of IET, Ghana and an experienced Building Construction Engineer; IFC EDGE Auditor; IFC EDGE Expert, with twenty (20) years of progressive working experience in project conception, design and supervision in the Architectural, Engineering & Construction industry. Samuel has an edge to develop an innovative building construction composite material to lower the cost of construction.</p>
  </div>
  <div className="col-6">
  <p style={{margin: '0', fontWeight: 'bold'}}>Emmanuel Appiah-Kubi, Co-Founder, Structural Engineering Director & Bamboo Expert</p>
  <p className="text-justify">Ing. Dr. Emmanuel Appiah-Kubi is a member of the “International Organization for Standardization” (ISO) Technical Committee on Bamboo & Rattan; a Research Scientist at CSIR-FORIG, Kumasi, Ghana and a Senior Lecturer at the Department of Construction and Wood Technology (University of Education, Winneba). He had his BSC, MPhil and PhD Degrees in Civil Engineering from the KNUST, Kumasi Ghana and has had a lot of international research stays at the Georg-August University of Goettingen, Germany and the Bern University of Applied Sciences, Biel, Switzerland.</p>
  </div>
</div>
<hr style={{margin: 0, backgroundColor: 'green'}} className="w-100"/>
<div className="row">
<div className="col-6">
<p style={{margin: '0', fontWeight: 'bold'}}>Ing. Dr. Anthony Andrews, Co-Founder, Director of Materials Technology & Engineering</p>
<p className="text-justify">Anthony Andrews currently works at the Department of Materials Engineering, Kwame Nkrumah University of Science and Technology. He does research in Ceramic processing, focusing on development of both traditional and advanced ceramic materials including refractories. Current projects focus on lithomargic clay utilization and surface modification</p>
</div>
<div className="col-6">
<p style={{margin: '0', fontWeight: 'bold'}}>Dr. Eward Yeboah, Co-Founder, Director of Soils & Biochar</p>
<p className="text-justify" >Dr. Edward Yeboah is a Principal Research Scientist and Deputy Director of the Council for Scientific and Industrial Research-Soil Research Institute, Kumasi, Ghana. Dr Yeboah is a Member of the International Biochar Initiative and a Steering Committee Member of African Biochar Partnership as well a Steering Committee member of the SIANI African Biochar Expert Group. Dr. Yeboah is the President of the International Foundation for Science-Ghana Alumni (IFS-Alumni, Ghana). He obtained his PhD in Soil Science, and has been working at CSIR-Soil Research Institute since 1998. In 2005, he spent six months working with Prof Johannes Lehmann Lab Group in Cornell University, Ithaca, New York. In 2006, he obtained the prestigious Rothamsted Research African Fellowship to become a Visiting Scientist at Rothamsted Research, UK.  </p>
</div>
</div>
<hr style={{margin: 0, backgroundColor: 'green'}} className="w-100"/>
<div className="row">
<div className="col-6">
<p style={{margin: '0', fontWeight: 'bold'}}>Mrs. Favour Mawuwoe Worwui, Director of Marketing</p>
<p className="text-justify">Favour Worwui has fourteen (14) years’ experience in business administration and teaching with successful track record of paying attention to detail. She holds first degree in Management Studies (BMS) and Post Graduate Diploma in Education.</p>
</div>
<div className="col-6">
<p style={{margin: '0', fontWeight: 'bold'}}>Michael Vandyke, Director of Finance</p>
<p className="text-justify">Michael Vandyke is a business systems analyst and management consultant with SCG Associates, accredited distributors of Pastel Accounting software in Ghana. He has over 5-years’ experience consulting on private sector projects and over 17 years of progressive accounting experience. He has extensive experience in systems analysis and design, development planning, monitoring and evaluating systems, computerization of financial management systems. </p>
</div>
</div>
<hr style={{margin: 0, backgroundColor: 'green'}} className="w-100"/>
<div className="col-6">
  <p style={{margin: '0', fontWeight: 'bold'}}>Engr. Mrs. Dorothy Manu, Advisor - Construction Manager,</p>
  <p className="text-justify">Engr. Mrs. Dorothy Manu currently works at the Department of Construction and Wood Technology Education, University of Education Winneba, Kumasi Campus. Dorothy does research in Sustainable Cementitious Materials that can be used to improve the mechanical and durability properties of soil Brick/Blocks for the construction of Affordable Eco-Housing Units.</p>
</div>
            </div>
            </div>
            
            
            <div className="mt-5">
            <h2 className="text-center">STAFF</h2>
            <hr style={{margin: 0, backgroundColor: 'green'}} className="w-100"/>
            <p className="text-center mt-3">Our headcount will be 30 at 31 December 2020</p>
            </div>
            
      </div>
    </div>
      </div>
       
      
    </div>
    )
  }
}
export default withRouter(Skills);
